import React from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLanguage } from '../../services/LanguageContextProvider'
import { localizedPath } from '../../i18n/locales'
import '../../css/pages/HorecaTeaser.css'

// Lightweight HORECA promo on the landing page. The full 3D configurator lives
// on its own indexable route (/horeca) — this avoids duplicate content while
// keeping the #horeca-section anchor the navbar links to.
export const HorecaTeaser = () => {
  const { t } = useTranslation('global')
  const { language } = useLanguage()

  return (
    <section id="horeca-section" className="horeca-teaser">
      <h2 className="horeca-teaser-title">{t('horeca.title')}</h2>
      <p className="horeca-teaser-subtitle">{t('horeca.subtitle')}</p>
      <Link className="horeca-teaser-cta" to={localizedPath(language, 'horeca')}>
        {t('horeca.teaserCta')}
      </Link>
    </section>
  )
}
